// extracted by mini-css-extract-plugin
export default {"Checkbox__label":"Checkbox_Checkbox__label__h9M4-","disabled":"Checkbox_disabled__EwLfX","Checkbox__button":"Checkbox_Checkbox__button__y3bZV","checked":"Checkbox_checked__3DBzf"};